export const DOC_TYPE = {
  CI: 'CI',
  RUT: 'RUT',
};
